// extracted by mini-css-extract-plugin
module.exports =  {"list":"gWCzx4LlhQ_H7qRnKVwb"};